// import { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import SearchProducts from './SearchProducts';
// import AuthContext from '../contexts/AuthContext';
import { AmplifySignOut } from '@aws-amplify/ui-react';

export const Header = () => {
  // const {setAuthState} = useContext(AuthContext);
  const history = useHistory();

  // XXX: update AuthContext on signout
  const handleAuthStateChange = (state) => {
    if (state === 'signedout') {
      console.log('Signed Out');
      history.push('/');
    }
  };
  
  return (
    <Navbar bg="light" expand="lg">
      <Navbar.Brand id="header-brand">
        <Nav.Link className="header-title" href="https://facecake.com">
          <img
            className="header-logo"
            alt="FaceCake"
            src="https://cdn.facecake.com/images/logos/facecake-logo-300.png"
          />
        </Nav.Link>
        <Nav.Link className="header-title" href="/">
          ASSET LAB
        </Nav.Link>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="header-navbar-nav" />
      <Navbar.Collapse id="header-navbar-nav">
        <Nav className="mr-auto"></Nav>
        <SearchProducts />
        <Navbar.Text id="header-sign-out">
          <AmplifySignOut handleAuthStateChange={handleAuthStateChange} />
        </Navbar.Text>
      </Navbar.Collapse>
    </Navbar>
  );
}
